import { PriceType } from '@client/product/components/ProductData/PriceList';
import { ProductEffectivePricingType } from 'b2b-common/core/product/api/Product.types';

export type Props = {
  effectivePricing: {
    hasB2BUserPrices: ProductEffectivePricingType['hasB2BUserPrices'];
    userPriceWithoutVat: ProductEffectivePricingType['userPriceWithoutVat'];
    userPrice: ProductEffectivePricingType['userPrice'];
    listPriceWithoutVat: ProductEffectivePricingType['listPriceWithoutVat'];
    listPrice: ProductEffectivePricingType['listPrice'];
  };
  text: {
    userPriceWithoutVat: string;
    userPrice: string;
    listPriceWithoutVat: string;
    listPrice: string;
    listPriceWithVatNumberText: string;
  }
}

export type SecondaryPrices = {
  userPriceWithoutVat?: PriceType;
  userPrice?: PriceType;
  listPriceWithoutVat?: PriceType;
  listPrice: PriceType;
}

export const getProductSecondaryPrices = ({
  effectivePricing: {
    hasB2BUserPrices,
    userPriceWithoutVat,
    userPrice,
    listPriceWithoutVat,
    listPrice,
  },
  text,
}: Props): SecondaryPrices => ({
  ...(hasB2BUserPrices && {
    userPriceWithoutVat: {
      price: userPriceWithoutVat,
      tax: text.userPriceWithoutVat,
    },
    userPrice: {
      price: userPrice,
      tax: text.userPrice,
    },
    listPriceWithoutVat: {
      price: listPriceWithoutVat,
      tax: text.listPriceWithoutVat,
    },
  }),
  listPrice: {
    price: listPrice,
    tax: hasB2BUserPrices
      ? text.listPrice
      : text.listPriceWithVatNumberText,
  },
});
